import { Button, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Host, OlaggModule, PermissionEnum } from "@olagg/db-types";
import { hostSchema } from "@olagg/validation-schemas";
import { useForm } from "react-hook-form";
import OlaggForm from "../../../components/Forms/OlaggForm";
import OlaggFormInput from "../../../components/Forms/OlaggFormInput";
import useRoles from "../../../features/Roles/hooks/useRoles";

type IProps = {
    host?: Host;
    onSubmit: (dataForm: any) => void;
};

const HostForm = ({ onSubmit, host }: IProps) => {
    const { missingPermission } = useRoles();
    const useFormMethods = useForm<Partial<Host>>({
        resolver: yupResolver(hostSchema),
        mode: 'onChange',
        defaultValues: host
    });

    return (
        <OlaggForm
            useFormMethods={useFormMethods}
            onSubmit={onSubmit}
            style={{
                width: '100%'
            }}
        >
            <VStack color={'white'} w={'full'} maxW='800px' margin='0 auto'>
                <OlaggFormInput
                    label='Nombre'
                    controlName='name'
                    description='Nombre del host'
                    required={true}
                />
                <OlaggFormInput
                    label='Avatar URL'
                    controlName='avatar'
                    description='URL del avatar del host'
                    required={true}
                />
                <OlaggFormInput
                    label='Perfil URL'
                    controlName='profileLink'
                    description='URL del perfil del host (opcional)'
                    required={true}
                />

                <Button
                    variant={'filledGradient'}
                    type="submit"
                    w={'full'}
                    style={{
                        marginTop: '30px'
                    }}
                    isDisabled={
                        missingPermission(OlaggModule.Event, host ? PermissionEnum.EDIT : PermissionEnum.CREATE)
                    }
                >
                    Guardar
                </Button>
            </VStack>
        </OlaggForm>
    )
};

export default HostForm;

